import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleCountryFilter } from '@client/redux/loggedInUser/loggedInUserActions';

const NO_COUNTRIES = [];

function sameCountries(a, b) {
  return a.length === b.length && a.every((code) => b.includes(code));
}

// The admin's country filter. The selection is held locally while the
// selector is open and only applied (once) on commit, and only if it differs
// from the saved filter. Applying it reloads the page.
function useCountryFilter() {
  const dispatch = useDispatch();
  const saved = useSelector(
    (state) => state.loggedInUserReducer.userInfo.countryFilter || NO_COUNTRIES
  );
  const [selected, setSelected] = useState(saved);

  // The profile arrives after this first renders (once the Session is restored).
  useEffect(() => {
    setSelected(saved);
  }, [saved]);

  function toggle(code) {
    setSelected((current) =>
      current.includes(code)
        ? current.filter((existing) => existing !== code)
        : [...current, code]
    );
  }

  function commit() {
    if (!sameCountries(selected, saved)) {
      dispatch(handleCountryFilter(selected));
    }
  }

  return { selected, toggle, commit };
}

export default useCountryFilter;
